<template>
    <div class="conss">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/mine' }">个人中心</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/mine' }">我的订单</el-breadcrumb-item>
            <el-breadcrumb-item>订单号 {{info.order_no}}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="ordewrs flx">
            <div class="orderleft">
                <div class="odtitle">
                    收货人信息
                </div>
                <div class="olitem flx">
                    <div class="olname">
                        收货人:
                    </div>
                    <div class="olvalue" v-text="info.address_name">

                    </div>
                </div>
                <div class="olitem flx">
                    <div class="olname">
                        地址:
                    </div>
                    <div class="olvalue" v-text="info.address_detail">

                    </div>
                </div>
                <div class="olitem flx">
                    <div class="olname">
                        手机号码:
                    </div>
                    <div class="olvalue" v-text="info.address_tel">

                    </div>
                </div>
                <div class="olitem flx">
                    <div class="olname">
                        订单留言:
                    </div>
                    <div class="olvalue" v-text="info.remark">

                    </div>
                </div>
            </div>
            <div class="ordermiddle">
                <div class="odtitle">
                    配送信息
                </div>
                <div class="olitem flx">
                    <div class="olname">
                        配送方式:
                    </div>
                    <div class="olvalue">
                        商家配送
                    </div>
                </div>
                <div class="olitem flx">
                    <div class="olname">
                        运费:
                    </div>
                    <div class="olvalue" v-text="info.total_freight_price"></div>
                </div>
                <div class="olitem flx" v-if="info.express_no">
                    <div class="olname">
                        物流信息:
                    </div>
                    <div class="olvalue" v-text="`${info.express_no} (${info.express_company})`">

                    </div>
                </div>
            </div>
            <div class="orderRight">
                <div class="odtitle">
                    订单信息
                </div>
                <div class="olitem flx">
                    <div class="olname">
                        订单号:
                    </div>
                    <div class="olvalue" v-text="info.order_no"></div>
                </div>
                <div class="olitem flx">
                    <div class="olname">
                        创建时间:
                    </div>
                    <div class="olvalue" v-text="info.createtime_text">

                    </div>
                </div>
            </div>
        </div>

        <div class="ordersContent">

            <div class="orderItems">
                <div class="orderTitles flx alc">
                    <div class="orderTitle1">
                        订单详情
                    </div>
                    <div class="orderTitle2">
                        金额
                    </div>
                    <div class="orderTitle3">
                        订单状态
                    </div>
                    <div class="orderTitle4">
                        操作
                    </div>
                </div>
                <div class="orderItem">
                    <div class="orderContent flx">
                        <div class="orderc1 flx">
                            <div class="orderImage">
                                <img :src="$img(info.goods_avatar)" alt="" />
                            </div>
                            <div>
                                <div class="orderGoodsName" v-text="info.goods_name"></div>
                                <div class="goodsSpec" v-text="info.spec_name"> </div>
                            </div>

                            <div class="ordernum">
                                ×{{info.num}}
                            </div>
                        </div>
                        <div class="orderc2">
                            <div class="topor" v-text="`￥${info.goods_price}`"></div>
                            <div class="botor">
                                微信支付
                            </div>
                        </div>
                        <div class="orderc3">
                            <div class="topor" style="color: #666666;" v-text="`${info.order_status_text2}`"></div>
                            <div class="botor cursor" @click="toDetail(info)">
                                订单详情 &gt;
                            </div>
                        </div>
                        <div class="orderc4">
                            <div class="btstyle1" v-if="info.order_status == 10" @click="repays">
                                马上支付
                            </div>
                            <div class="btstyle1" v-if="info.order_status == 30" @click="receiveOrder">
                                确认收货
                            </div>
                            <div class="btstyle2" v-if="info.order_status == 10" @click='cancelOrder'>
                                取消订单
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="prices">
            <div class="priceItem flx alc">
                <div class="pricename">
                    商品总价
                </div>
                <div class="priceVal" v-text="`￥${info.goods_price * info.num}`">

                </div>
            </div>
            <div class="priceItem flx alc">
                <div class="pricename" v-text="info.order_status == 10?'需付款' : '已付款'">

                </div>
                <div class="priceVal" style="font-weight: bold;font-size: 18px;" v-text="`￥${info.total_price}`">

                </div>
            </div>
        </div>
        <wechatpay @rfh="getDetail" v-if="showALert" @close="showALert=false" :type="'books'" :source="'repay'"
            :orderNo="info.order_no" :codeUrl="pay_code_url"></wechatpay>
    </div>
</template>

<script>
    import {
        getBookOrderDetail,
        confirmRecieve,
        cencelbORder,
        repayborder
    } from "@/api/index.js"
    import wechatpay from "@/components/wechatpay.vue"
    export default {
        name: 'OrderDetail',
        components: {
            wechatpay
        },
        data() {
            return {
                info: {},
                showALert: false,
                pay_code_url: ""
            }
        },
        mounted() {
            this.getDetail()
        },
        methods: {
            repays() {
                let that = this
                let data = {}
                data.order_id = that.$route.query.id
                repayborder(data).then((res) => {
                    console.log(res)
                    if (res.code == 1) {
                        that.pay_code_url = res.data.code_url
                        that.info.order_no = res.data.order_no
                        that.showALert = true
                    } else {
                        that.$message({
                            type: 'error',
                            message: res.msg
                        });
                    }
                })
            },
            receiveOrder() {
                let that = this
                let data = that.$route.query.id
                that.$confirm('您确定收到货物了吗?', ' ', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    confirmRecieve(data).then((res) => {
                        if (res.code == 1) {
                            that.$message({
                                type: 'success',
                                message: res.msg
                            });
                            that.getList()
                        } else {
                            that.$message({
                                type: 'error',
                                message: res.msg
                            });
                        }
                    })
                }).catch(() => {

                });
            },
            cancelOrder(e) {
                let that = this
                let data = {}
                data.order_id = that.$route.query.id
                that.$confirm('确定要取消该订单吗?', ' ', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    cencelbORder(data).then((res) => {
                        if (res.code == 1) {
                            that.$message({
                                type: 'success',
                                message: res.msg
                            });
                            that.getList()
                        } else {
                            that.$message({
                                type: 'error',
                                message: res.msg
                            });
                        }
                    })
                }).catch(() => {

                });

            },
            getDetail() {
                let that = this
                let data = {}
                data.order_id = that.$route.query.id
                getBookOrderDetail(data).then((res) => {
                    console.log(res)
                    if (res.code == 1) {
                        that.info = res.data
                    } else {
                        that.$message({
                            type: 'error',
                            message: res.msg
                        });
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .pricename {
        font-size: 14px;
        color: #666666;

    }

    .priceVal {
        width: 93px;
        font-size: 14px;
        color: #FF0F23;
        line-height: 21px;
        text-align: right;
    }

    .priceItem {
        justify-content: flex-end;
        margin-top: 30px;
    }

    .goodsSpec {
        font-size: 12px;
        margin-top: 10px;
        color: #999999;
    }

    .btstyle2 {
        font-size: 12px;
        color: #666666;
        line-height: 21px;
        margin-top: 6px;
        cursor: pointer;
    }

    .btstyle1 {
        width: 74px;
        height: 24px;
        border-radius: 2px 2px 2px 2px;
        border: 1px solid #E4393C;
        color: #E4393C;
        text-align: center;
        line-height: 24px;
        font-size: 12px;
        cursor: pointer;
    }

    .topor {
        text-align: center;
        padding: 6px 0;
        border-bottom: 1px solid #D9D9D9;
        font-weight: 600;
        font-size: 14px;
        color: #333333;
    }

    .botor {
        text-align: center;
        padding: 8px 0;
        font-size: 12px;
        color: #999999;
        line-height: 21px;
    }

    .ordernum {
        font-size: 14px;
        color: #999999;
        flex: 1;
        text-align: right;
    }

    .orderGoodsName {
        font-weight: 600;
        font-size: 14px;
        color: #666666;
        width: 240px;
    }

    .orderImage {
        width: 80px;
        height: 80px;
        margin-right: 10px;
    }

    .orderImage img {
        width: 100%;
        height: 100%;
        border-radius: 6px;
    }

    .orderContent {
        background: #fff;
    }

    .orderItems {
        margin-top: 21px;
        max-height: 780px;
        overflow-y: auto;
    }

    .orderTit {
        height: 32px;
        background: #F2F2F2;
        width: 100%;
        box-sizing: border-box;
        padding: 0 20px;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
    }

    .orderItem {
        width: 99.8%;
        border: 1px solid #D9D9D9;
    }

    .orderTitles {
        height: 32px;
        background: #F2F2F2;
        width: 100%;

    }

    .orderc1 {
        width: 505px;
        height: 128px;
        box-sizing: border-box;
        padding: 24px;
        border-right: 1px solid #D9D9D9;
    }

    .orderc2 {
        width: 209px;
        height: 128px;
        border-right: 1px solid #D9D9D9;
        display: flex;
        flex-direction: column;
        justify-content: center;
        box-sizing: border-box;
        padding: 20px;
    }

    .orderc3 {
        width: 176px;
        height: 128px;
        border-right: 1px solid #D9D9D9;
        display: flex;
        flex-direction: column;
        justify-content: center;
        box-sizing: border-box;
        padding: 20px;
    }

    .orderc4 {
        flex: 1;
        height: 128px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .orderTitle1 {
        width: 505px;
        text-align: center;
        font-weight: 500;
        font-size: 14px;
        color: #666666;
    }

    .orderTitle2 {
        width: 209px;
        text-align: center;
        font-weight: 500;
        font-size: 14px;
        color: #666666;
    }

    .orderTitle3 {
        width: 176px;
        text-align: center;
        font-weight: 500;
        font-size: 14px;
        color: #666666;
    }

    .orderTitle4 {
        flex: 1;
        text-align: center;
        font-weight: 500;
        font-size: 14px;
        color: #666666;
    }

    .orderRight {
        flex: 1;
        box-sizing: border-box;
        padding: 30px;
    }

    .ordermiddle {
        width: 341px;
        box-sizing: border-box;
        padding: 30px;
        border-right: 1px solid #D9D9D9;
    }

    .orderleft {
        box-sizing: border-box;
        padding: 30px;
        width: 516px;
        border-right: 1px solid #D9D9D9;
    }

    .odtitle {
        font-weight: 600;
        font-size: 16px;
        color: #333333;
        margin-bottom: 20px;
    }

    .olname {
        width: 70px;
        text-align: right;
        margin-right: 12px;
    }

    .olitem {
        font-size: 14px;
        color: #333333;
        margin-bottom: 14px;
    }

    .ordewrs {
        width: 100%;
        background: #fff;
        margin-top: 16px;
        text-align: left;
    }

    .conss {
        width: 1200px;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 20px 0;
    }
</style>